import { NgModule } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';

import { CamtlContactsComponent } from './camtl-contacts.component';
import { CamtlProgramContactsComponent } from './camtl-program-contacts/camtl-program-contacts.component';
import { CamtlProjectContactsComponent } from './camtl-project-contacts/camtl-project-contacts.component';
import { CamtlSourceContactsComponent } from './camtl-source-contacts/camtl-source-contacts.component';
import { CamtlZoneContactsComponent } from './camtl-zone-contacts/camtl-zone-contacts.component';

@NgModule({
    imports: [
        SharedModule,
    ],
    declarations: [
        CamtlContactsComponent,
        CamtlProgramContactsComponent,
        CamtlProjectContactsComponent,
        CamtlSourceContactsComponent,
        CamtlZoneContactsComponent,
    ],
    exports: [
        CamtlContactsComponent,
        CamtlProgramContactsComponent,
        CamtlProjectContactsComponent,
        CamtlSourceContactsComponent,
        CamtlZoneContactsComponent,
    ],
    providers: []

})
export class CamtlContactsModule { }
